import { DeleteProjectGroup } from '@/connection/projects/delete-project-group';
import { serializeError } from '@/store/utils/serialize-error';
import { ProjectsReducerCreator } from '../types';

const deleteProjectGroupReducer = (create: ProjectsReducerCreator) => {
  return create.asyncThunk(
    async ({ channel, groupUuid }: { channel: number; groupUuid: string }, { rejectWithValue }) => {
      try {
        const res = DeleteProjectGroup(channel, groupUuid);
        return res;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        if (state.projectGroups) {
          const remainingProjectGroups = state.projectGroups.filter(
            (eg) => eg.uuid !== action.payload.deletedGroupUuid
          );

          return {
            ...state,
            projectGroups: remainingProjectGroups,
            groupToDelete: null,
          };
        } else {
          return state;
        }
      },
    }
  );
};

export default deleteProjectGroupReducer;
